<template>
  <div class="report-filter report-manager">
    <div class="ms-help">
      {{ type === "manager" ? "Менеджер:" : "Полевой ГИП:" }}
    </div>
    <i-select
      v-model="value"
      style="width: 180px;"
      multiple
      placeholder="Все"
      filterable
    >
      <i-option v-for="item in managers" :value="item.id" :key="item.id">
        {{ item.name }}
      </i-option>
    </i-select>
  </div>
</template>

<script>
import { getFullName } from '@/utils'

export default {
  props: {
    type: {
      type: String,
      validator: value => ['manager', 'field_managers'].includes(value),
      default: 'manager'
    }
  },
  computed: {
    managers () {
      const { managers, fieldManagers } = this.$store.state.contracts
      const items = this.type === 'manager' ? managers : fieldManagers

      return [
        { id: 'null', name: 'Не указан' },
        ...items
          .map(u => ({
            ...u,
            name: getFullName(u)
          }))
          .sort((a, b) => {
            if (a.name > b.name) return 1
            if (a.name < b.name) return -1
            return 0
          })
      ]
    },
    value: {
      get () {
        if (this.type === 'manager') {
          return this.$store.state.reports.manager
        }

        return this.$store.state.reports.field_managers
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: this.type,
          value
        })
      }
    }
  }
}
</script>

<style lang="less">
.report-manager {
  display: flex;
  align-items: center;

  .ms-help {
    margin-right: 8px;
  }
}
</style>
